import { Injectable } from '@angular/core';
import { SharedService } from '../shared.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductMasterService {
 
  url;
  constructor(private sharedService: SharedService, private httpClient: HttpClient) {
    this.url = this.sharedService.baseURL;
  }
  createProduct(productMaster: any) {
    return this.httpClient.post<any>(`${this.url}/api/ProductMaster/CreateProduct`, productMaster);
  }
  loadProducts(event: any) {
    return this.httpClient.post<any>(`${this.url}/api/ProductMaster/Products`, event);
  }
  loadProductsForDdl(event: any) {
    return this.httpClient.post<any>(`${this.url}/api/ProductMaster/ProductsForDDL`, event);
  }
  saveProductConfig(config: any): any {
    return this.httpClient.post<any>(`${this.url}/api/ProductMaster/ProductConfiguration`, config);
  }
  getProductConfig(config: any): any {
    return this.httpClient.post<any>(`${this.url}/api/ProductMaster/GetProductConfig`, config);
  }
  deleteProduct(data: any) {
    return this.httpClient.post<any>(`${this.url}/api/ProductMaster/DeleteProduct`, data);
  }
  upload(formData) {
    return this.httpClient.post(`${this.url}/api/ProductMaster/UploadMultiProducts`, formData)
  }
}
